import React from 'react';
// import * as CodeMirror from 'codemirror';
import brace from 'brace';
import AceEditor from 'react-ace';
import PropertyEditor from "../PropertyEditor";
import PropertyGridUtils from '../PropertyGridUtils';

import "brace/mode/json";
import { Button, Tooltip, Icon, Popover, } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { SvgIconText } from "freesia-ui";

export default class JsonObjectEditor extends PropertyEditor {

    state = {
        width: 150,
        id: `ace-${Math.random()}`,
        showLargeCode: false,
        value: "",
    };

    div = null;

    constructor(props, context) {
        super(props, context);
    }

    onChange(value) {
        this.setState({ value });
    }

    onBlur() {
        try {
            let value = this.state.value;
            let obj = value ? JSON.parse(value.trim()) : null;
            this.props.source.value = obj;
            this.setState({ value });
        }
        catch (err) {
            console.warn(err);
        }
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        let value = valNew ? JSON.stringify(valNew, null, '    ') : "";
        this.setState({ value });
    }

    componentDidMount() {

        let value = this.props.source.value;
        value = value ? JSON.stringify(value, null, '    ') : "";
        this.setState({ value });

        this.unregisterResizeHandler = this.props.propertyGrid.registerResizeHandler(() => this.resize());

        setTimeout(() => {
            this.resize();
        }, 100);
    }

    componentWillReceiveProps(nextProps) {
        super.componentWillReceiveProps(nextProps);

    }

    componentWillUnmount() {

        super.componentWillUnmount();
        if (this.unregisterResizeHandler)
            this.unregisterResizeHandler();
    }

    onBeforeLoad(ace) {
        let editor = ace.edit(this.state.id + '-editor');
        editor && editor.getSession().setUseWorker(false);
    }

    resize() {
        this.div = this.div || document.getElementById(this.state.id);
        if (this.div)
            this.setState({ width: (this.div.clientWidth - 1) || 150 });

        setTimeout(() => {
            this.div = this.div || document.getElementById(this.state.id);
            if (this.div)
                this.setState({ width: (this.div.clientWidth - 1) || 150 });
        }, 1);
    }

    render() {

        if (this.div)
            this.state.width = (this.div.clientWidth - 2) || 150;

        let errorMsg = this.props.source.errorMsg;
        let editorProps = {
            height: "200px",
            width: `${this.state.width}px`
        }
        let { showLargeCode } = this.state;
        let bigCodeStyle = {}
        if (showLargeCode) {
            let width = `${this.state.width + 60}px`;
            bigCodeStyle = {
                width: width,
                /* height: 100px; */
                // border: "1px solid #ddd",
                position: "fixed",
                top: "70px",
                // background: "#fff",
                bottom: -1,
                /* left: 0; */
                right: 0,
                zIndex: 1001
            }
            editorProps = {
                height: "100%",
                width: width
            }
        }

        let aceEditor = <AceEditor
            mode={"json"}
            theme="chrome"
            enableBasicAutocompletion={true}
            showGutter={true}
            value={this.state.value}
            onBlur={this.onBlur.bind(this)}
            onChange={this.onChange.bind(this)}
            onBeforeLoad={this.onBeforeLoad.bind(this)}
            name={this.state.id + '-editor'}
            wrapEnabled={false}
            {...editorProps}
        />;
        return (
            <div key="1" id={this.state.id} className="csseditor" style={{
                lineHeight: 'normal',
                position: 'relative'
            }}>
                <div className="layout-v" style={bigCodeStyle}>
                    <div className="layout-h center code-toolbar" style={{ paddingRight: showLargeCode ? 5 : 0 }}>
                        <div className="fill"></div>
                        {/* {this.format &&
                            <Button
                                title={"格式化 Alt+Shift+F"}
                                className='btn-bd-hover btn-pd-sm'
                                onClick={() => this.format()}>
                                <SvgIconText type={'#anticon-tsconfigjson'} />
                            </Button>
                        } */}
                        <Button
                            title={showLargeCode ? "还原" : "最大化"}
                            className='btn-bd-hover btn-pd-sm sp-left'
                            onClick={() => this.setState({ showLargeCode: !showLargeCode })}>
                            <SvgIconText type={showLargeCode ? "#anticon-zoomout" : "#anticon-zoomin"} />
                        </Button>
                    </div>
                    <div className="code-editor fill h0">
                        {aceEditor}
                        {errorMsg && <Popover placement="topRight" title={"错误提示"} content={<div>{errorMsg}</div>} trigger="click">
                            <div style={{
                                position: "absolute",
                                right: 0,
                                bottom: 0,
                                color: '#f00'
                            }}>
                                <ExclamationCircleOutlined type="exclamation-circle" />
                            </div>
                        </Popover>}
                    </div>


                </div>

                {/* <textarea id={`textarea-${this.props.source.id}`} style={{ height: 50 }}></textarea> */}
            </div>
        );
    }
}

PropertyGridUtils.register("jsonobject", (source, propertyGrid) => <JsonObjectEditor source={source} propertyGrid={propertyGrid} />);
